import { ComponentRef, Injectable, ViewContainerRef } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { BehaviorSubject } from 'rxjs';
interface PortalComponentData {
  component: ComponentRef<any>;
  title: string;
  subtitle?: string;
  height?: string;
}
@Injectable({
  providedIn: 'root',
})
export class ComponentPortalService {
  private _componentInstance$ = new BehaviorSubject<PortalComponentData | null>(
    null
  );

  public drawer!: MatDrawer;
  public viewContainerRef?: ViewContainerRef;
  public currentComponentRef?: ComponentRef<any>;

  getComponentInstanceObservable() {
    return this._componentInstance$.asObservable();
  }

  setViewContainerRef(viewContainerRef: ViewContainerRef) {
    this.viewContainerRef = viewContainerRef;
  }

  initializeDrawerRef(drawer: MatDrawer) {
    this.drawer = drawer;
  }

  renderComponent(
    component: ComponentRef<any>,
    title: string,
    subtitle?: string,
    height?: string
  ) {
    this.openDrawer();
    this._componentInstance$.next({ component, title, subtitle, height });
  }

  closeDrawer() {
    if (this.drawer) {
      this.drawer.close();
    }
  }

  openDrawer() {
    if (this.drawer) {
      this.drawer.open();
    }
  }

  clearComponent() {
    this.viewContainerRef?.clear();
    this.currentComponentRef = null;
  }
}
